module.exports = __webpack_public_path__ + "img/pic6.da7e0fc4.png";